export { default } from "@src/Apps/ForgotPassword";
